import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import VisorPDF from "../../components/Viewer/VisorPDF";
import BackdropComponent from "../../components/BackDrop";
import { FileService } from "../../services/FileService.js";
import { DocumentService } from "../../services/DocumentService.js";
import { Icon } from "@iconify/react";

export const B64toBlob = async (b64Data, contentType = "", sliceSize = 512) => {
  var atob = require("atob");
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

const b64toUrl = async (base64Data) => {
  const r = await fetch(base64Data);
  const blob = await r.blob();
  return URL.createObjectURL(blob);
};

const convertWordToPdf = async (wordB64) => {
  const fileService = FileService.getInstance();
  const response = await fileService.convertWordToPdf(wordB64);
  return response;
};

const convertWordB64ToPdfB64 = async (b64) => {
  const wordToPdf = await convertWordToPdf(b64);
  const wordPdfB64 = `data:application/pdf;base64,${wordToPdf.Body}`;
  const wordUrl = await b64toUrl(wordPdfB64);
  return wordUrl;
};

export const MassiveFlowDocumentViewer = (props) => {
  const [listDocumentFieldData, setlistDocumentFieldData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [urlImagen, setUrlImagen] = useState(null);
  const [expanded, setExpanded] = useState(false);

  // Control de estados
  const fileState = useSelector((state) => state.File);
  const RelatedMassiveFileDataState = useSelector(
    (state) => state.File?.item?.RelatedMassiveFileData
  );

  //Peticiones a apis
  const dispatch = useDispatch();

  useEffect(async () => {
    console.log("RelatedMassiveFileDataState: ", RelatedMassiveFileDataState);
    if (RelatedMassiveFileDataState?.length > 0) {
      let listDocuments = [];
      await RelatedMassiveFileDataState.forEach(async (item) => {
        console.log(
          "DonwloadListDocument -----item-------------------: ",
          item
        );
        const documentServiceInstance = DocumentService.getInstance();
        let comentData = await documentServiceInstance.GetDocumentToSignContent(
          {
            File_Id: item.Id,
          }
        );
        console.log(
          "DonwloadListDocument -----Response-------------------: ",
          comentData
        );
        if (comentData.Body) {
          console.log(
            "DonwloadListDocument ------------------------: ",
            comentData.Body
          );
          const blob = await B64toBlob(
            comentData?.Body?.Response?.B64Content,
            "application/pdf"
          );
          // setBlobUrl(URL.createObjectURL(blob));
          listDocuments.push({
            urlBob: URL.createObjectURL(blob),
            Name: `${comentData?.Body?.Response?.FileName} - ${item.Id}`,
          });
        }
      });
      console.log("-------+++++listDocuments+++--------: ", listDocuments);
      setlistDocumentFieldData(listDocuments);
    }
  }, [RelatedMassiveFileDataState]);

  useEffect(() => {
    if (fileState?.item?.FileData?.Id > 0) {
      traerCodigoQR();
    }
  }, [fileState?.item?.FileData?.Id]);

  const traerCodigoQR = async () => {
    const fileService = FileService.getInstance();
    const comentData = await fileService.getFileQR({
      idFile: fileState?.item?.FileData?.Id,
      token: sessionStorage.token,
    });
    const url = window.URL.createObjectURL(new Blob([comentData.data.data]));
    setUrlImagen(url);
  };

  // const handleAccordionChange = (data) => {
  //   console.log("handleAccordionChange-----------: ", expanded, !expanded, data)
  //   if (!expanded == false) {
  //     setCurrentlySelectedDocument(data);
  //     traerDocumentos(data.Id)
  //   }
  //   setExpanded(!expanded);
  // };

  return (
    <Fragment>
      <BackdropComponent loading={loading} />
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          sx={{
            //border: "1px solid #E4E4E4",
            p: 1,
            mt: 0,
          }}
        >
          <Grid item sx={{ mt: 0 }}>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Typography variant="h6" sx={{ fontWeight: 500 }}>
                Documentos a firmar
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ fontWeight: 300 }}>
              Los siguientes documentos representan la versión final, si estás
              de acuerdo presiona el botón “firmar”.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          sx={{
            //border: "1px solid #E4E4E4",
            p: 0,
            mt: 0,
          }}
        >
          {listDocumentFieldData?.map((itemData, index) => (
            <Accordion
              disableGutters
              defaultExpanded={index == 0} /// onChange={() => { handleAccordionChange(itemData) }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                  p: 0,
                  "&.Mui-expanded": {
                    color: "#C20E30" /* Cambia este color por el que desees */,
                    borderRadius: "3px",
                    border: "1px solid #C20E30",
                    background: "rgba(194, 14, 48, 0.15)",
                  },
                  "& .MuiAccordionSummary-content": {
                    m: 0,
                  }
                }}
              >
                <Box sx={{ p: 1, display: "flex", alignItems: "center" }}>
                  <Icon
                    icon="solar:document-broken"
                    fontSize={23}
                    style={{ padding: 1, marginRight: 2 }}
                  />
                  <Typography
                    variant="titulo"
                    sx={{ fontSize: "20px !important" }}
                  >
                    {itemData.Name}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails style={{ paddingLeft: 0, paddingTop: 16 }}>
                <Box
                  sx={{
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 0,
                    flexWrap: { xs: "wrap" },
                  }}
                >
                  {itemData.urlBob ? (
                    <VisorPDF
                      pdfUrl={itemData.urlBob ?? ""}
                      pdfName={itemData.Name ?? ""}
                    />
                  ) : (
                    <Spinner />
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </Grid>
    </Fragment>
  );
};

const Spinner = () => {
  return (
    <Box sx={{ display: "grid", placeContent: "center", height: 500 }}>
      <CircularProgress size={60} />
    </Box>
  );
};
